import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["box", "code", "button", "resend", "countdown"]
  static values = { cooldown: Number }

  connect() {
    if (this.hasBoxTarget) this.boxTargets[0].focus()
    if (this.hasCountdownTarget) this.startCountdown(this.cooldownValue || 60)
  }

  input(e) {
    const i = this.boxTargets.indexOf(e.target)
    e.target.value = e.target.value.replace(/\D/g, "").slice(0, 1)
    if (e.target.value && i < this.boxTargets.length - 1) this.boxTargets[i + 1].focus()
    this.sync()
    this.maybeSubmit()
  }

  keydown(e) {
    const i = this.boxTargets.indexOf(e.target)
    if (e.key === "Backspace" && !e.target.value && i > 0) this.boxTargets[i - 1].focus()
  }

  paste(e) {
    const text = (e.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "").slice(0, this.boxTargets.length)
    if (!text) return
    e.preventDefault()
    text.split("").forEach((c, i) => { if (this.boxTargets[i]) this.boxTargets[i].value = c })
    this.sync()
    this.maybeSubmit()
  }

  sync() {
    if (this.hasCodeTarget) this.codeTarget.value = this.boxTargets.map((b) => b.value).join("")
  }

  maybeSubmit() {
    if (this.hasBoxTarget && this.boxTargets.every((b) => b.value)) {
      const form = this.element.querySelector("form") || this.element.closest("form")
      if (form) form.requestSubmit()
    }
  }

  submit() {
    if (!this.hasButtonTarget) return
    const b = this.buttonTarget
    setTimeout(() => {
      b.disabled = true
      const text = b.dataset.loadingText
      if (text) { if (b.tagName === "INPUT") b.value = text; else b.textContent = text }
    }, 0)
  }

  startCountdown(seconds) {
    let t = seconds
    const render = () => {
      if (t <= 0) {
        clearInterval(this.timer)
        if (this.hasResendTarget) this.resendTarget.classList.remove("hidden")
        if (this.hasCountdownTarget) this.countdownTarget.classList.add("hidden")
        return
      }
      this.countdownTarget.textContent = `Neuen Code in 0:${t < 10 ? "0" : ""}${t}`
      t -= 1
    }
    render()
    this.timer = setInterval(render, 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }
}
